var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlThumbnailVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    viewBox: "0 0 100 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 56,
    rx: 6,
    fill: "#BA82DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 55,
    rx: 5.5,
    stroke: "#2A2A2A",
    strokeOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 16C56.7879 16 57.5681 16.1552 58.2961 16.4567C59.0241 16.7583 59.6855 17.2002 60.2426 17.7574C60.7998 18.3145 61.2417 18.9759 61.5433 19.7039C61.8448 20.4319 62 21.2121 62 22V34C62 34.7879 61.8448 35.5681 61.5433 36.2961C61.2417 37.0241 60.7998 37.6855 60.2426 38.2426C59.6855 38.7998 59.0241 39.2417 58.2961 39.5433C57.5681 39.8448 56.7879 40 56 40H44C43.2121 40 42.4319 39.8448 41.7039 39.5433C40.9759 39.2417 40.3145 38.7998 39.7574 38.2426C39.2002 37.6855 38.7583 37.0241 38.4567 36.2961C38.1552 35.5681 38 34.7879 38 34V22C38 21.2121 38.1552 20.4319 38.4567 19.7039C38.7583 18.9759 39.2002 18.3145 39.7574 17.7574C40.8826 16.6321 42.4087 16 44 16H56ZM45.4972 23.5748C45.4238 23.7109 45.3857 23.8632 45.3865 24.0178V31.984C45.3865 32.144 45.4282 32.3013 45.5074 32.4404C45.5865 32.5794 45.7005 32.6955 45.8381 32.7773C45.9757 32.859 46.1322 32.9036 46.2922 32.9066C46.4522 32.9096 46.6102 32.871 46.7508 32.7945L54.0523 28.8105C54.1979 28.7311 54.3195 28.6139 54.4042 28.4713C54.4889 28.3287 54.5335 28.1659 54.5335 28C54.5335 27.8341 54.4889 27.6713 54.4042 27.5287C54.3195 27.3861 54.1979 27.2689 54.0523 27.1895L46.7508 23.2055C46.6442 23.1473 46.5273 23.1107 46.4066 23.0978C46.2859 23.0849 46.1639 23.0959 46.0474 23.1302C45.931 23.1645 45.8225 23.2214 45.728 23.2977C45.6336 23.374 45.5552 23.4681 45.4972 23.5748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlThumbnailVideo);
export default __webpack_public_path__ + "static/media/il-thumbnail-video.184cabf2e25965cb5162256fa2eb5bf3.svg";
export { ForwardRef as ReactComponent };